'use client'

import { Fragment, useState } from 'react'

import { Search } from 'lucide-react'

import { SidebarCollapsible } from '~/components/component-library/internal/Sidebar/components/SidebarCollapsible'
import { SidebarDivider } from '~/components/component-library/internal/Sidebar/components/SidebarDivider'
import { searchComponents } from '~/components/component-library/internal/Sidebar/utils'
import { Input } from '~/components/inputs/Input'

export const ComponentLibrarySidebar = () => {
  const [query, setQuery] = useState('')

  const isSearching = query.trim().length > 0
  const results = searchComponents(query)

  return (
    <>
      <Input
        inputSize="small"
        value={query}
        placeholder="Search components..."
        prefix={<Search className="size-3.5 text-secondary" />}
        onChange={(event) => setQuery(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setQuery('')
        }}
        onClearInput={isSearching ? () => setQuery('') : undefined}
      />
      <div className="h-2" />
      {results.map((props) => (
        <Fragment key={props.name}>
          <SidebarCollapsible {...props} forceOpen={isSearching} />
          <SidebarDivider />
        </Fragment>
      ))}
      {isSearching && results.length === 0 && (
        <p className="px-2 py-4 text-center text-sm text-secondary">
          No components found
        </p>
      )}
    </>
  )
}
